import { useCallback, useMemo } from 'react';
import {
  paymentPageRightSidePanelState,
  setActivePanelView,
  useAppDispatch,
  useAppSelector,
} from 'src/store';
import { PaymentPageRightSidePanelType } from 'src/types';

export const useSubscriptionPageRightPanel = () => {
  const { activePanelView } = useAppSelector(paymentPageRightSidePanelState);
  const dispatch = useAppDispatch();

  const changeActivePanelView = useCallback(
    (value: PaymentPageRightSidePanelType | null) => {
      dispatch(setActivePanelView(value));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      activePanelView,
      changeActivePanelView,
    }),
    [activePanelView, changeActivePanelView],
  );
};
